export default __webpack_public_path__ + "static/media/edit-icon-asset.2674adfe.svg";